import { Flexbox } from '@hiiretail/synergy-ui';
import { CircularProgress } from '@material-ui/core';
import styled from 'styled-components';
import { LoadingSpinnerComponent } from './LoadingSpinner.types';

const SpinnerContainer = styled(Flexbox)`
  width: 100%;
  height: 100%;
`;

export const LoadingSpinner: LoadingSpinnerComponent = ({ circularProgressProps }) => {
  return (
    <SpinnerContainer data-testid="loading-spinner" container alignItems="center" justifyContent="center">
      <CircularProgress color="primary" size={150} {...circularProgressProps} />
    </SpinnerContainer>
  )
};
